/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : core.jsx
 * description   : {{insert here}}
 * creation date : 14/01/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

// --------------------------------------------------
//     Authenticator
// --------------------------------------------------

const auth_routes =
{
    SIGN_IN: 'sign-in',
    SIGN_UP: 'sign-up',
    RESET_PASSWORD: 'reset-password',

    get list() {
        return (
            [
                this.SIGN_IN,
                this.SIGN_UP,
                this.RESET_PASSWORD,
            ]
        );
    },
};

// --------------------------------------------------
//     Location
// --------------------------------------------------

const route_list =
{
    // Page not found
    PAGE_NOT_FOUND: '/404',

    // Home page
    HOME: '/',

    // Account pages
    ACCOUNT: '/account',

    // Authentication pages
    AUTH: '/auth',
    get AUTH_SIGN_IN() {
        return this.AUTH + '/' + auth_routes.SIGN_IN;
    },
    get AUTH_SIGN_UP() {
        return this.AUTH + '/' + auth_routes.SIGN_UP;
    },
    get AUTH_RESET_PASSWORD() {
        return this.AUTH + '/' + auth_routes.RESET_PASSWORD;
    },

    // Legal pages
    LEGAL: '/legal',
    PRIVACY: '/privacy',
    COOKIES: '/cookies',
    CONTACT: '/contact',

    // Demo pages
    DEMO: '/demo',
};

const search_list =
{
    RETURN_TO: 'returnTo',
};

const hash_list =
{
    // Presentation
    ABOUT: 'about',
    SERVICE: 'service',
    PROCESS: 'process',
    CLIENTS: 'clients',
    CONTACT: 'contact',
};

// --------------------------------------------------
//     IDs
// --------------------------------------------------

const id_list =
{
    ANNOUNCEMENT: 'announcement',
    NAVBAR: 'navbar',
    FOOTER: 'footer',
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    auth_routes,
    route_list,
    search_list,
    hash_list,
    id_list,
};



// End of file
